module.exports = __webpack_public_path__ + "static/media/multiplesample.a3c5fcfd.pdf";